module.exports = __webpack_public_path__ + "img/explorer.8feae2ef.png";